import clsx from 'clsx';
import { useEffect, useRef } from 'react';

import styles from './TextLabel.module.scss';

interface TextLabelProps {
  label?: string;
  x: number;
  y?: number;
  hasProfit?: boolean;
}

const BG_HEIGHT_PX = 24;
const BG_HEIGHT_HALF_PX = BG_HEIGHT_PX / 2;
const BG_PADDING_PX = 8;
const BG_BORDER_RADIUS_PX = 8;

export const TextLabel = ({ label, x, y, hasProfit }: TextLabelProps) => {
  const textRef = useRef<SVGTextElement>(null);
  const backgroundRef = useRef<SVGRectElement>(null);

  useEffect(() => {
    if (textRef.current && backgroundRef.current) {
      const textBoundingClientRect = textRef.current.getBoundingClientRect();
      const backgroundWidth = textBoundingClientRect.width + BG_PADDING_PX * 2;
      backgroundRef.current.setAttribute('width', backgroundWidth.toFixed());
    }
  }, [textRef.current, backgroundRef.current]);

  return (
    <g data-testid="svg-tooltip-label">
      <rect
        ref={backgroundRef}
        className={clsx(styles.rect, {
          [styles.rectProfit]: hasProfit,
        })}
        height={BG_HEIGHT_PX}
        y={y ?? -BG_HEIGHT_HALF_PX}
        x={x}
        rx={BG_BORDER_RADIUS_PX}
      />

      <text
        ref={textRef}
        className={clsx(styles.text, {
          [styles.textProfit]: hasProfit,
        })}
        alignmentBaseline="central"
        x={x + BG_PADDING_PX}
        y={y ? y + BG_HEIGHT_HALF_PX : undefined}
      >
        {label}
      </text>
    </g>
  );
};
